import { render, staticRenderFns } from "./BookstoreBilling.vue?vue&type=template&id=59a4b0fc&scoped=true&"
import script from "./BookstoreBilling.vue?vue&type=script&lang=js&"
export * from "./BookstoreBilling.vue?vue&type=script&lang=js&"
import style0 from "./BookstoreBilling.vue?vue&type=style&index=0&id=59a4b0fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a4b0fc",
  null
  
)

export default component.exports